/* eslint-disable */
<template>
  <div class="my-4 ma-md-5 mx-lg-10 mx-xl-10 maxw-1750">
    <v-row
      no-gutters
      v-bind:class="[
        'mx-2 align-center',
        {
          'flex-column justify-center': !$vuetify.breakpoint.mdAndUp,
        },
      ]"
    >
    </v-row>

    <h2>{{ $t("views.profileEdit.titleSection") }}</h2>

    <v-row justify="center" class="pa-md-0 pa-2 ma-md-0 ma-2 mt-md-4">
      <v-expansion-panels tile :value="openPanel">
        <!-- Inicio de sesion -->
        <v-expansion-panel v-if="!isCitizen()">
          <v-expansion-panel-header color="white" class="color-border" dark>
            <template v-slot:actions>
              <v-icon class="primary--text"> $expand </v-icon>
            </template>
            <div>
              <span class="primary--text">
                {{ $t("views.profileEdit.session.title") }}
              </span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content v-if="loadingSession">
            <v-skeleton-loader
              v-for="i in 5"
              :key="i"
              class="mx-auto"
              type="list-item-avatar-two-line"
            >
            </v-skeleton-loader>
          </v-expansion-panel-content>
          <v-expansion-panel-content class="pt-4" v-else>
            <v-data-table
              :headers="headersLastSessions"
              :items="registerSession"
              :items-per-page="5"
              :hide-default-footer="true"
            >
              <template v-slot:item.fecha="{ item }">
                 <span>{{ $date("formatTime", item.fecha) }}</span>
              </template>
              <template v-slot:item.soporte="{ item }">
                 <span>{{item.soporte?item.soporte:$t('views.profileEdit.session.unknow')}}</span>
              </template>
              <template v-slot:item.sistemaOperativo="{ item }">
                 <span>{{item.sistemaOperativo!=='null'?item.sistemaOperativo:'-'}}</span>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!--Permisos app -->
        <v-expansion-panel class="ma-1" v-if="get('deviceOS')">
          <v-expansion-panel-header color="white" class="color-border" dark>
            <template v-slot:actions>
              <v-icon class="primary--text"> $expand </v-icon>
            </template>
            <div>
              <span class="primary--text">
                {{ $t("views.permissionsMobile.title") }}
              </span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content v-if="loadingSession">
            <v-skeleton-loader
              v-for="i in 5"
              :key="i"
              class="mx-auto"
              type="list-item-avatar-two-line"
            >
            </v-skeleton-loader>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-else>
            <v-list-item v-for="(permission, i) in permissions" :key="i">
              <v-list-item-avatar>
                <v-icon> {{ permission.icon }} </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class="text-wrap" v-html="permission.title">
                </v-list-item-title>
                <v-list-item-subtitle
                  class="text-wrap"
                  v-html="permission.subtitle"
                >
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- dispositivos registrados -->
        <v-expansion-panel class="ma-1" v-if="!isCitizen()">
          <v-expansion-panel-header color="white" class="color-border" dark>
            <template v-slot:actions>
              <v-icon class="primary--text"> $expand </v-icon>
            </template>
            <div>
              <span class="primary--text">
                {{ $t("views.devices.title") }}
              </span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content v-if="loadingSession">
            <v-skeleton-loader
              v-for="i in 5"
              :key="i"
              class="mx-auto"
              type="list-item-avatar-two-line"
            >
            </v-skeleton-loader>
          </v-expansion-panel-content>
          <v-expansion-panel-content class="pt-4" v-else>

            <v-data-table
              :headers="headersDevices"
              :items="devices"
              hide-default-footer
              class="pa-0 tableDevice"
            >
              <template v-slot:item.znombre_dispositivo="{ item }">
                <v-text-field
                  :class="$vuetify.breakpoint.xs ? 'text-r' : ''"
                  v-model="item.znombre_dispositivo"
                  @change="renameDevice(item.znombre_dispositivo, item.zdeviceid)"
                ></v-text-field>
              </template>
              <template v-slot:item.last_mod_dt="{ item }">
                <span>{{ $date("formatTime", item.last_mod_dt) }}</span>
              </template>
              <template v-slot:item.accion="{ item }">
                <a
                  @click="unregisterDevice(item.zdeviceid)"
                >
                {{ $t('views.profileEdit.session.logoutDevicesLink') }}
                </a>
              </template>
            </v-data-table>

            <!-- Modal accion eliminar-->
            <v-dialog v-model="dialog" class="mx-auto" max-width="300">
              <v-card>
                <v-card-title>
                  {{
                    $t("views.security.unregisterDevice.dialog", [
                      deviceMarca,
                      deviceModelo,
                    ])
                  }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    @click="unregisterDevice(deviceId)"
                  >
                    {{ $t("views.security.unregisterDevice.accept") }}
                  </v-btn>
                  <v-btn text @click="dialog = false">
                    {{ $t("views.security.unregisterDevice.cancel") }}
                  </v-btn>

                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Modal accion renombrar-->
            <v-dialog v-model="rename" class="mx-auto" max-width="500">
              <v-card>
                <v-card-title>
                  {{
                    $t("views.security.renameDevice.dialog", [
                      deviceMarca,
                      deviceModelo,
                    ])
                  }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-text-field
                    label="Nombre del dispositivo"
                    maxlength="150"
                    v-model="name"
                  ></v-text-field>

                  <v-btn
                    color="primary"
                    text
                    @click="renameDevice(name, deviceId)"
                  >
                    {{ $t("views.security.renameDevice.accept") }}
                  </v-btn>
                  <v-btn text @click="rename = false">
                    {{ $t("views.security.renameDevice.cancel") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- normativa-->
        <v-expansion-panel class="ma-1">
          <v-expansion-panel-header color="white" class="color-border" dark>
            <template v-slot:actions>
              <v-icon class="primary--text"> $expand </v-icon>
            </template>
            <div>
              <span class="primary--text">
                {{ $t("views.legalDisclaimer.title") }}
              </span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-4" id="securityDisclaimer">
            <span v-html="$t('views.legalDisclaimer.body')"></span>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- accesibilidad-->
        <v-expansion-panel class="ma-1" v-if="get('deviceOS')">
          <v-expansion-panel-header color="white" class="color-border" dark>
            <template v-slot:actions>
              <v-icon class="primary--text"> $expand </v-icon>
            </template>
            <div>
              <span class="primary--text">
                {{ $t("views.accesibility.title") }}
              </span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-4">
            <span v-html="$t('views.accesibility.body')"></span>
          </v-expansion-panel-content>
        </v-expansion-panel>
          <!-- eliminar cuenta solo apple-->
        <v-expansion-panel class="ma-1" v-if="isCitizen()">
          <v-expansion-panel-header color="white" class="color-border" dark>
            <template v-slot:actions>
              <v-icon class="primary--text"> $expand </v-icon>
            </template>
            <div>
              <span class="primary--text">
                {{ $t("views.deleteAccount.title") }}
              </span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-4">
            <span v-html="$t('views.deleteAccount.body')"></span>
          <v-card-actions
            class="justify-end col-12 px-2 mt-4 mt-md-0">
            <v-btn color="primary"
              @click="$router.push('/logout')">
              {{ $t("views.deleteAccount.delete") }}
            </v-btn>
          </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { NAMED_ROLES } from '@/store/modules/session';

export default {
  name: 'SecurityView',

  data() {
    return {
      sessions: [],
      loading: false,
      registerSession: [],
      devices: [],
      headersDevices: [
        { text: 'Marca/Modelo', value: 'zmarca_modelo' },
        { text: 'Alias', value: 'znombre_dispositivo' },
        { text: 'Último acceso', value: 'last_mod_dt' },
        { text: '', value: 'accion' },
      ],
      headersLastSessions: [
        { text: '', value: '' },
        { text: 'Fecha/hora', value: 'fecha' },
        { text: 'Navegador', value: 'soporte' },
        { text: 'Sistema operativo', value: 'sistemaOperativo' },
      ],
      thirdParty: [
        { resource: 'axios', version: '0.19.2', license: 'MIT License' },
        { resource: 'common-errors', version: '1.0.5', license: '-' },
        { resource: 'core-js', version: '3.6.5', license: 'MIT License' },
        { resource: 'cropperjs', version: '1.5.9', license: 'MIT License' },
        { resource: 'error-polyfill', version: '0.1.2', license: 'MIT License' },
        { resource: 'file-saver', version: '2.0.5', license: '-' },
        { resource: 'grunt-run', version: '0.8.1', license: '-' },
        { resource: 'lodash.merge', version: '4.6.2', license: 'MIT License' },
        { resource: 'moment', version: '2.27.0', license: 'MIT License' },
        { resource: 'pako', version: '2.0.3', license: 'MIT License' },
        { resource: 'pulltorefreshjs', version: '0.1.21', license: 'MIT License' },
        { resource: 'register-service-worker', version: '1.7.1', license: '-' },
        { resource: 'systemjs-webpack-interop', version: '2.1.1', license: 'MIT License' },
        { resource: 'vue', version: '2.6.11', license: 'MIT License' },
        { resource: 'vue-cropperjs', version: '4.1.0', license: 'MIT License' },
        { resource: 'vue-fragment', version: '1.5.1', license: 'MIT License' },
        { resource: 'vue-i18n', version: '8.18.2', license: 'MIT License' },
        { resource: 'vue-plugin-load-script', version: '2.1.1', license: 'MIT License' },
        { resource: 'vue-recaptcha', version: '1.3.0', license: 'MIT License' },
        { resource: 'vue-router', version: '3.2.0', license: 'MIT License' },
        { resource: 'vuetify', version: '2.5.13', license: 'MIT License' },
        { resource: 'vuex', version: '3.4.0', license: 'MIT License' },
        { resource: 'vuex-persist', version: '2.2.0', license: 'MIT License' },
        { resource: '@vue/cli-plugin-babel', version: '~4.4.0', license: 'MIT License' },
        { resource: '@vue/cli-plugin-eslint', version: '~4.4.0', license: 'MIT License' },
        { resource: '@vue/cli-plugin-pwa', version: '~4.4.0', license: 'MIT License' },
        { resource: '@vue/cli-plugin-router', version: '~4.4.0', license: 'MIT License' },
        { resource: '@vue/cli-plugin-unit-jest', version: '~4.4.0', license: 'MIT License' },
        { resource: '@vue/cli-plugin-vuex', version: '~4.4.0', license: 'MIT License' },
        { resource: '@vue/cli-service', version: '~4.4.0', license: 'MIT License' },
        { resource: '@vue/eslint-config-airbnb', version: '5.0.2', license: 'MIT License' },
        { resource: '@vue/test-utils', version: '1.0.3', license: 'MIT License' },
        { resource: 'babel-eslint', version: '10.1.0', license: 'MIT License' },
        { resource: 'cross-env', version: '7.0.3', license: 'MIT License' },
        { resource: 'eslint', version: '6.7.2', license: 'MIT License' },
        { resource: 'eslint-import-resolver-alias', version: '1.1.2', license: 'MIT License' },
        { resource: 'eslint-plugin-import', version: '2.20.2', license: 'MIT License' },
        { resource: 'eslint-plugin-vue', version: '6.2.2', license: 'MIT License' },
        { resource: 'grunt', version: '1.3.0', license: '-' },
        { resource: 'grunt-exec', version: '3.0.0', license: 'MIT License' },
        { resource: 'grunt-gitinfo', version: '0.1.9', license: 'MIT License' },
        { resource: 'grunt-prompt', version: '1.3.3', license: 'MIT License' },
        { resource: 'grunt-remove-logging', version: '0.2.0', license: '' },
        { resource: 'grunt-simple-git', version: '1.0.1', license: 'MIT License' },
        { resource: 'grunt-ssh', version: '0.12.9', license: 'MIT License' },
        { resource: 'grunt-text-replace', version: '0.4.0', license: 'MIT License' },
        { resource: 'grunt-timer', version: '0.6.0', license: 'MIT License' },
        { resource: 'grunt-webpack', version: '4.0.2', license: 'MIT License' },
        { resource: 'node-sass', version: '4.12.0', license: 'MIT License' },
        { resource: 'sass', version: '1.32.0', license: 'MIT License' },
        { resource: 'sass-loader', version: '8.0.2', license: 'MIT License' },
        { resource: 'vue-cli-plugin-vuetify', version: '2.0.5', license: 'MIT License' },
        { resource: 'vue-template-compiler', version: '2.6.11', license: 'MIT License' },
        { resource: 'vuetify-loader', version: '1.3.0', license: 'MIT License' },
        { resource: 'webpack', version: '4.43.0', license: 'MIT License' },
        { resource: 'webpack-cli', version: '3.3.12', license: 'MIT License' },
        { resource: 'webpack-merge', version: '4.2.2', license: 'MIT License' },
      ],
      headersThirdParty: [
        { text: 'Recurso', value: 'resource' },
        { text: 'Versión', value: 'version' },
        { text: 'Tipo de licencia', value: 'license' },
      ],
      loadingSession: true,
      dialog: false,
      rename: false,
      name: '',
      deviceModelo: '',
      deviceMarca: '',
      deviceId: '',
      permissions: [
        {
          title: this.$t('views.permissionsMobile.list.internet.title'),
          icon: 'mdi-web',
          subtitle: this.$t('views.permissionsMobile.list.internet.subtitle'),
        },
        {
          title: this.$t('views.permissionsMobile.list.readAndWrite.title'),
          icon: 'mdi-micro-sd',
          subtitle: this.$t(
            'views.permissionsMobile.list.readAndWrite.subtitle',
          ),
        },
        {
          title: this.$t('views.permissionsMobile.list.biometric.title'),
          icon: 'mdi-fingerprint',
          subtitle: this.$t('views.permissionsMobile.list.biometric.subtitle'),
        },
        {
          title: this.$t('views.permissionsMobile.list.camera.title'),
          icon: 'mdi-camera',
          subtitle: this.$t('views.permissionsMobile.list.camera.subtitle'),
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
      get: 'globalState/get',
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
    color() {
      // eslint-disable-next-line no-bitwise
      const hash = this.user.fullName
        .split('')
        .reduce((tot, curr) => curr.charCodeAt(0) + ((tot < 5) - tot), 0);
      return Array.from({ length: 3 }, (_, i) => i).reduce((acum, idx) => {
        // eslint-disable-next-line no-bitwise
        const val = (hash >> (idx * 8)) & 0xff;
        return acum + `00${val.toString(16)}`.substr(-2);
      }, '#');
    },
    openPanel() {
      return 0;
    },
  },
  methods: {
    calculateSymbol(soporte, sistemaOperativo) {
      if (sistemaOperativo !== null && sistemaOperativo !== 'null') {
        return this.$t(`views.profileEdit.session.symbol.${sistemaOperativo.toLowerCase()}`);
      }
      const symbol = soporte ? soporte.split(' ')[0].toLowerCase() : 'unknow';
      if (!this.$te(`views.profileEdit.session.symbol.${symbol}`)) {
        return this.$t('views.profileEdit.session.symbol.unknow');
      }
      return this.$t(`views.profileEdit.session.symbol.${symbol}`);
    },
    async loadSession() {
      const sessions = await this.$api.getClient('registerSession').list();
      const { list } = sessions;
      if (list != null && list[0] != null) {
        this.registerSession = list[0].sessions;
      }
      this.loadingSession = false;
    },
    async loadDevices() {
      const client = this.$api.getClient('search');
      const response = await client.search({
        entity: 'zapp_user',
        match: 'zuserid',
        fields:
          'zuserid,zmarca,zmodelo,last_mod_dt,zdeviceid,znombre_dispositivo,zversion,last_mod_dt',
        filters: `{"zuserid":"${this.user.id}", "zmarca": { "$distinct": "null" }, "zinactivo":"0"}`,
        lookandfeel: '#item.zmarca',
        target: 'backend',
        order: 'last_mod_dt desc',
        size: 5, // max items allowed by servcges
      });

      const { list } = response;
      const listDevices = [
        ...new Map(list.map((item) => [item.zdeviceid, item])).values(),
      ].map((props) => (
        {
          ...props,
          zmarca_modelo: `${props.zmarca} - ${props.zmodelo}`,
        }
      ));
      this.devices = listDevices.slice(0, 5);
    },
    async unregisterDevice(deviceId) {
      this.dialog = false;
      this.loadingSession = true;
      const { id, userid } = this.$store.getters['session/user'];
      const data = {
        apiCges: {
          delegado: userid,
          endpoint: `cges/contactos/${id}/dispositivos`,
          idDispositivo: deviceId,
        },
        idDispositivo: deviceId,
        id,
      };
      await this.$api.getClient('contacs').deleteDevice(data);
      await this.loadDevices();
      this.loadingSession = false;
    },
    async renameDevice(newName, deviceId) {
      this.loadingSession = true;
      this.rename = false;
      await this.$api
        .getClient('registerSession')
        .renameDevice(newName, deviceId);
      await this.loadDevices();
      this.loadingSession = false;
    },
    itemName(marca, modelo) {
      return `${marca} - <span style="color: rgba(0, 0, 0, 0.6);">${modelo}</span>`;
    },
    isCitizen() {
      return this.user.hasIosUser();
    },

  },

  created() {
    this.NAMED_ROLES = NAMED_ROLES;
    if (!this.isCitizen()) {
      this.loadSession();
      this.loadDevices();
    }
  },
};
</script>
<style lang="scss" scoped>
$header-padding: 10 0;
.bar-intro {
  height: 3px !important;
}
.color-border {
  border: 1px solid !important;
  border-color: #002060 !important;
}
.v-expansion-panel-header {
  padding: $header-padding;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: initial;
}
#securityDisclaimer{
  word-break: break-word;

  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  hyphens: auto;
}
::v-deep .v-data-table-header{
  background-color: #27846d !important;
  border-color: #27846d !important;
  border: 1px solid !important;
}
::v-deep .sortable{
  color: white !important;
}
::v-deep .tableDevice tbody tr:nth-child(even) { background-color: #FFF !important; }
::v-deep .tableDevice tbody tr:nth-child(odd) { background-color: #F1F1F1 !important; }
::v-deep .v-input__slot::before { border: none !important; }
::v-deep input { font-size: 0.875rem !important; }
::v-deep .text-r input{ text-align: right !important; }
</style>
